import { getNumericAspectRatio } from './getNumericAspectRatio';
export const DEFAULT_LOSSY_IMAGE_QUALITY = 79;
export const DEFAULT_FORMAT = 'png';
export const getRemoteDynamicMediaUrl = (request, requiredWidth, config) => {
    const optionalParams = request.params;
    const format = optionalParams && optionalParams.format
        ? optionalParams.format
        : DEFAULT_FORMAT;
    const seoName = (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.seoName) || 'image';
    const assetId = request.assetId;
    const remote = config.remotes.find(r => r.repositoryId === request.repositoryId);
    if (!remote) {
        return '/no-remote-found.jpq';
    }
    const baseUrl = remote.url;
    const url = new URL(`${baseUrl}/${assetId}/as/${seoName}.${format}`);
    const quality = (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.quality) || DEFAULT_LOSSY_IMAGE_QUALITY;
    url.searchParams.append('quality', String(quality));
    if (!(optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.aspectRatio)) {
        url.searchParams.append('width', String(requiredWidth));
    }
    else {
        appendCrop(url.searchParams, optionalParams.aspectRatio, optionalParams.focalPoint, request, requiredWidth);
    }
    return url.toString();
};
function appendCrop(searchParams, aspectRatio, focalPoint = { x: 'center', y: 'center' }, request, requiredWidth) {
    const requiredHeight = aspectRatio
        ? Math.round(requiredWidth / getNumericAspectRatio(aspectRatio))
        : undefined;
    searchParams.append('size', `${requiredWidth},${requiredHeight}`);
    const dimension = getNewDimension(request.metaData.originalWidth, request.metaData.originalHeight, getNumericAspectRatio(aspectRatio), focalPoint);
    if (!dimension) {
        return;
    }
    searchParams.append('crop', `${dimension.left}p,${dimension.top}p,${dimension.width}p,${dimension.height}p`);
}
function getNewDimension(originalWidth, originalHeight, aspectRatio, focalPoint) {
    const originalAspectRatio = originalWidth / originalHeight;
    if (originalAspectRatio === aspectRatio) {
        return undefined;
    }
    if (originalAspectRatio < aspectRatio) {
        const heightLoss = originalHeight - originalWidth / aspectRatio;
        const { offset, size } = getPercentage(heightLoss, originalHeight, focalPoint.y);
        return { left: 0, top: offset, width: 100, height: size };
    }
    const widthLoss = originalWidth - originalHeight * aspectRatio;
    const { offset, size } = getPercentage(widthLoss, originalWidth, focalPoint.x);
    return { left: offset, top: 0, width: size, height: 100 };
}
const CROPPING_OFFSET_PERCENTAGE = 1;
function getPercentage(reduction, originalSize, alignment) {
    const offsetPercentage = twoDigits((reduction / originalSize / 2) * 100);
    const sizePercentage = twoDigits(((originalSize - reduction) / originalSize) * 100);
    switch (alignment) {
        case 'center':
            return { offset: offsetPercentage, size: sizePercentage };
        case 'left':
            return {
                offset: (1 - CROPPING_OFFSET_PERCENTAGE) * offsetPercentage,
                size: sizePercentage
            };
        case 'right':
            return {
                offset: (1 + CROPPING_OFFSET_PERCENTAGE) * offsetPercentage,
                size: sizePercentage
            };
        case 'top':
            return {
                offset: (1 - CROPPING_OFFSET_PERCENTAGE) * offsetPercentage,
                size: sizePercentage
            };
        case 'bottom':
            return {
                offset: (1 + CROPPING_OFFSET_PERCENTAGE) * offsetPercentage,
                size: sizePercentage
            };
    }
}
/*(W0-DW0/H0-DH0)  = a

W0/H0>a      ->    DH0=0   ->      DW0 = W0-  a*H0          , a=1     200/100      ->   DW0=200-100=100
                                                            , a=2     300/100      ->   DW0=300-100=200

W0/H0<a      ->    DW0=0   ->      DH0 = H0 - W0/a         , a=1     100/200      ->   DH0=200-100=100
*/
function twoDigits(value) {
    return Math.trunc(value * 100) / 100;
}
